<template>
  <div class="relative container1400">
    <v-item-group mandatory v-model="data.type">
      <v-container>
        <h2 class="text-h5 mt-6 mb-6 font-weight-regular text-left">
          {{ $t("Cmsg7") }}
        </h2>
        <v-row>
          <v-col v-for="n in listType" :key="n" cols="12" md="4">
            <v-item v-slot="{ active, toggle }" :value="n">
              <v-card
                :color="active ? 'grey white--text' : ''"
                @click="toggle"
                class="text-center pt-10"
                height="100%"
              >
                <v-icon class="right-top" v-if="active" dark>
                  mdi-check-circle
                </v-icon>
                <img
                  :src="$store.state.baseUrl + 'icons/' + n + '.png'"
                  height="60px"
                />
                <div class="subtitle-1 text-center pa-5">{{ $t(n) }}</div>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>
    <v-container>
      <div class="text-right">
        <v-btn
          outlined
          color="grey"
          large
          class="mr-2"
          @click="$emit('goBack')"
          >{{ $t("Back") }}</v-btn
        >
        <v-btn large color="light-blue white--text" rounded @click="next">
          <span class="mr-2">{{ $t("Continue") }}</span>
          <v-icon size="small">mdi-arrow-right-thick</v-icon>
        </v-btn>
      </div>
    </v-container>
    <v-snackbar v-model="step1Error" absolute color="red">
      {{ $t("SelectSomeValue") }}
    </v-snackbar>
  </div>
</template>

<script>
import listingsData from "@/assets/listings.json";

export default {
  props: ["data"],
  name: "Step1Component",
  components: {},
  data() {
    return {
      listType: listingsData.listType,
      step1Error: false
    };
  },
  methods: {
    async next() {
      if (!this.data.type) {
        this.step1Error = true;
      } else {
        this.step1Error = false;
        this.data.steps = 2;
        window.scrollTo(0, 0);
      }
    }
  }
};
</script>

<style>
.right-top {
  position: absolute !important;
  right: 15px;
  top: 15px;
}
</style>
